//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RegisterCard from '../registerCard/index.vue';
import viewportMixin from '@/mixins/viewport.mixin';

export default {
  components: {
    RegisterCard,
  },
  mixins: [viewportMixin],
  computed: {
    displayRegisterDialog: {
      get() {
        return this.$store.state.event.displayRegisterDialog;
      },
      set(payload) {
        this.$store.commit('event/SET_DISPLAY_REGISTER_DIALOG', payload);
      },
    },
  },
};
